import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table-v6';
import '../../../../../styles/custom.css';
import { CustomNoDataComponent, makeFirstLetterCapital,convertDateToDifferentTZ, scheduledTaskPreviewDate } from '../../../../../utility/utility';
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import ReactTooltip from 'react-tooltip';
import * as actions from '../../../../../redux/actions/index';
import { useSelector, useDispatch } from 'react-redux';
import { ClapSpinner } from 'react-spinners-kit';
import 'react-table-v6/react-table.css';
var moment = require('moment');

let ChecklistSupervisiorTable = (props) => {

    const dispatch = useDispatch();
    // const SearchValue = useSelector(state => state.form.searchScheduledTask && state.form.searchScheduledTask.values ? state.form.searchScheduledTask.values : {});
    const DateGenerate = useSelector(state => state.FormAuditModReducer.dataGenerated);
    // const values = useSelector(state => state.FormAuditModReducer.scheduledTask_searchValues);
    const No_of_pages = useSelector(state => state.FormAuditModReducer.checklistSupervisor_total_pages);
    const No_of_rows = useSelector(state => state.FormAuditModReducer.checklistSupervisor_no_of_rows);
    const ischecklistSupervisor = useSelector(state => state.FormAuditModReducer.ischecklistSupervisor);
    const checklistSupervisorCurPage = useSelector(state => state.FormAuditModReducer.checklistSupervisorCurPage);
    const SearchOrResetScheduledTaskListClicked = useSelector(state => state.FormAuditModReducer.SearchOrResetScheduledTaskListClicked);

    const accountTimezone = 'America/Los_Angeles';

    const data = props.checklistSupervisor_list && props.checklistSupervisor_list.map((value) => {
        return {
            organization: makeFirstLetterCapital(value && value.company ? value.company.name : '-'),
            manager: value && value.manager ?  `${makeFirstLetterCapital(value.manager.first_name)} ${makeFirstLetterCapital(value.manager.last_name)}` : '-',
            month: value && value.month ? value.month : '-',
            year: value && value.year ? value.year : '-',
            supervisor: value && value.supervisor ?  `${makeFirstLetterCapital(value.supervisor.first_name)} ${makeFirstLetterCapital(value.supervisor.last_name)}` : '-',
            job: value && value.account ? value.account.name : '',
            cleaning_worker: value && value.sections  ?  `${makeFirstLetterCapital(value.sections.worker.first_name)} ${makeFirstLetterCapital(value.sections.worker.last_name)}` : '-',
            scheduled_date: value && value.sections ? scheduledTaskPreviewDate(value.sections.scheduled_date,value.account.timezone) : '',
            completed:value && value.sections  ? `${value.sections.completed ? "Yes" :"No"}` : '',
            date_of_completed: value && value.sections  ? scheduledTaskPreviewDate(value.sections.date_of_completed,value.account.timezone) : '',
            comments: value && value.sections  ? value.sections.comments : '',
            actions:
                <>
                <span className="mr_20 account_edit_icn" onClick={() => props.history.push(`team-checklist-supervisior-summary/view/${value.id}`)} ><i class="fas fa-eye" aria-hidden="true" ></i></span>
                {
                    props?.isCreateAccess ? <span className="mr_20 account_edit_icn" onClick={() => props.history.push(`team-checklist-supervisior-summary/${value.id}`)} ><i class="fa fa-pencil" aria-hidden="true" ></i></span> : null
                }
                
                </>
        }
    })

    const columns = [
        {
            Header: <><span> Organization </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'organization',
            show: props.checklistSupervisor_list.length !== 0,
            // width: 120,
        },
        {
            Header: <><span> Job </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'job',
            show: props.checklistSupervisor_list.length !== 0
        },
        {
            Header: <><span> Supervisor </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'supervisor',
            show: props.checklistSupervisor_list.length !== 0,
        },
        {
            Header: <><span> Manager </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'manager',
            show: props.checklistSupervisor_list.length !== 0,
        },
        {
            Header: <><span> Month</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'month',
            show: props.checklistSupervisor_list.length !== 0,
            width: 100,
        },
        {
            Header: <><span> Year</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'year',
            show: props.checklistSupervisor_list.length !== 0,
            width: 100,
        },
       
        {
            Header: <><span>Cleaning Worker </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'cleaning_worker',
            show: props.checklistSupervisor_list.length !== 0,
            width: 200,
        },
        {
            Header: <><span>Scheduled Date</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'scheduled_date',
            show: props.checklistSupervisor_list.length !== 0,
            // width: 245,
        },
        {
            Header: <><span>Completed </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'completed',
            show: props.checklistSupervisor_list.length !== 0,
            
        },
        {
            Header: <><span>Date Completed </span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'date_of_completed',
            show: props.checklistSupervisor_list.length !== 0,
            
        },
        {
            Header: <><span>Comments</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'comments',
            show: props.checklistSupervisor_list.length !== 0,
            width: 120,
        },
        {
            Header: '',
            accessor: 'actions',
            width: 100,
            sortable:false,
        }
    ]

    const [tablePage, setTablePage] = useState(0)
    const tablePageNew =  React.useRef()
    if(checklistSupervisorCurPage !== tablePageNew.current) {
        tablePageNew.current = checklistSupervisorCurPage;
      }
    const setTablePageFn = (page) => {
        setTablePage(page)
        props.ChecklistSupervisorListPageClicked(page)
        tablePageNew.current = page;
    }

    const fetchData = (state, instance) => {
        if (SearchOrResetScheduledTaskListClicked) {
            dispatch(actions.resetSearchOrResetInventory())
        } else {
            if (!DateGenerate && !props.ischecklistSupervisor) {
                state.page = 2;
                const limit = state.pageSize;
                let page = tablePageNew.current >= 0 ? tablePageNew.current + 1 : checklistSupervisorCurPage + 1;
                const inventoryItemsList_no_of_rows = state.pageSize;
                if(No_of_rows != inventoryItemsList_no_of_rows) {
                    page = 1;
                    setTablePageFn(0)
                }
                
                const order = state.sorted[0]?.id;
                const orderBy = state.sorted && state.sorted.length ? state.sorted[0]?.desc === true ? 'desc' : 'asc' : null;
                // const accountId = SearchValue.id ? SearchValue.id : null;
                // const taskName = SearchValue.name ? SearchValue.name : null;
                // const companyName = SearchValue.company ? SearchValue.company : null;
                // const accountName = SearchValue.job ? SearchValue.job : null;
                // const from = SearchValue.fromDate ? convertDateToDifferentTZ(SearchValue.fromDate, 'from') : null;
                // const to = SearchValue.toDate ? convertDateToDifferentTZ(SearchValue.toDate, 'to') : null;
                props.getAllChecklistSupervisor({page,limit, order,orderBy})
            }
        }
    }

    return (
        SearchOrResetScheduledTaskListClicked && props.ischecklistSupervisor ?
            <div  >
                <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
            </div>
            :
            <ReactTable
                data={data}
                loading={props.ischecklistSupervisor}
                minRows={0}
                defaultPageSize={No_of_rows}
                pages={No_of_pages}
                gotoPage={checklistSupervisorCurPage}
                page = { checklistSupervisorCurPage }
                onPageChange={(page) => {setTablePageFn(page)}}
                // onPageSizeChange={props.onUserPageSizeChange}
                manual
                onFetchData={fetchData}
                showPaginationTop={true}
                showPaginationBottom={false}
                showPagination={props.checklistSupervisor_list.length !== 0}
                columns={columns}
                // style={{marginTop: '10px'}}
                NoDataComponent={() => CustomNoDataComponent(ischecklistSupervisor, 'No Checklist Supervisor List Found')}
                LoadingComponent={() =>
                    ischecklistSupervisor ?
                        <div style={{
                            display: "block",
                            position: "absolute",
                            left: 0,
                            height: '100%',
                            right: 0,
                            background: "rgba(255,255,255,0.8)",
                            transition: "all .3s ease",
                            top: 0,
                            bottom: 0,
                            textAlign: "center"
                        }}
                            className="loader_btn_block">
                            <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
                        </div> : null}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    // console.log(column);
                    return {
                        style: {
                            borderTop: 'none',
                            borderBottom: 'none',
                            borderRight: 'none',
                            textAlign: 'center',
                            color: '#566975',
                            fontSize: '14px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                            float: 'left',
                        }
                    }
                }
                }
                getTrProps={(state, rowInfo, column, instance) => {
                    // onclick = () => userDetail(rowInfo ? rowInfo.row.user : rowInfo);
                    console.log(column);
                    return {
                        className: 'react-table-tr-element',
                        style: {
                            border: '1px solid #c7cdd1',
                            transition: '.3s ease-in-out',
                            width: '100%',
                            // borderRadius: '4px',
                            // height: '80px',
                            marginTop: '5px',
                            float: 'left'
                        }
                    }

                }}
                getTdProps={(state, rowInfo, column, instance) => {

                    if (column.id == 'image') {
                        return {
                            style: {
                                marginTop: '0px'
                            }
                        }
                    } else {
                        return {
                            className: 'react-td-element',
                        }
                        //  {
                        //   style: {
                        //     borderTop: 'none',
                        //     verticalAlign: 'middle',
                        //     fontSize: '14px',
                        //     color: '#2b3034',
                        //     marginTop: '10px !important',
                        //     textAlign: 'center',
                        //   }
                        // }
                    }
                }
                }
                // getPaginationProps={() => {
                //     return {
                //         style: {
                //             marginTop: '50px',
                //             border: 'none',
                //             boxShadow: 'none'
                //         }
                //     }
                // }
                // }
                getProps={() => {
                    return {
                        style: {
                            border: 'none'
                        }
                    }
                }}
            />
    )
}

export default ChecklistSupervisiorTable;